

































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";
// import { firstDayInPrevMonth, formatDateTime } from "@/global.ts";
import GlobalMixins from "../../../global.mixin";
import FileManagementDialog from "./FileManagementDialog.vue";
import InventoryHistoryDialog from "./InventoryHistoryDialog.vue";
import PrintLabelDialog from "./PrintLabelDialog.vue";
import {importExportApi} from "../../../services/api/importexport.api";
import PrintLabelOverlay from "./PrintLabelOverlay.vue";
import StatusConfirmationDialog from "./StatusConfirmationDialog.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";

import appSnackbarService from "../../../services/appSnackbar.service";

// import { printLabelState } from "../../../store/modules/printLabel.module";

@Component({
  mixins: [GlobalMixins],
  components: {
    FileManagementDialog,
    InventoryHistoryDialog,
    PrintLabelDialog,
    PrintLabelOverlay,
    StatusConfirmationDialog,
    DateRangePicker,
  }
})
export default class ProductView extends Vue {
  @State("products") productsState: any;
  @Action("getProducts") getProducts: any;
  @Action("saveProduct") saveProduct: any;
  @Action("deleteProduct") deleteProduct: any;

  // @State("locations") locationsState: any;
  // @Action("getLocations") getLocations: any;

  @State("sites") sitesState: any;
  @Action("getSites") getSites: any;

  @State("deviceTypes") deviceTypesState: any;
  @Action("getDeviceTypes") getDeviceTypes: any;

  @State("costCenters") costCentersState: any;
  @Action("getCostCenters") getCostCenters: any;

  @State("productStates") productStatesState: any;
  @Action("getProductStates") getProductStates: any;


  @State("socketState") socketState: any;
  @Action("initializeSignalR") initializeSignalR: any;
  @Action("printLabel") printZebraLabel: any;

  @State("printLabel") printLabelState: any;

  @Action("addToPrint") addToPrint: any;



  snackbar = false;
  snacktext = "";
  loader = false;
  search = "";

  locationsSearchTerm = "";
  locationsSearched: string[] = [];

  sitesSearchTerm = "";
  sitesSearched: string[] = [];

  deviceTypesSearchTerm = "";
  deviceTypesSearched: string[] = [];

  costCentersSearchTerm = "";
  costCentersSearched: string[] = [];

  productStatesSearchTerm = "";
  productStatesSearched: string[] = [];

  editingDialog = false;
  editedIndex = -1;
  isNewItem = false;
  formValid = false;

  inventoryHistoryDialog = false;
  selectedProduct = null;

  fileManagementDialog = false;
  printLabelDialog = false;

  printLabelOverlay = false;

  itemToDelete: any = null;
  itemIndexToDelete = -1;

  defaultItem = {
    productId: 0,
    productCode: "",
    productSubCode: "",
    color: "",
    size: "",
    barCode: "",
    manufactureCode: "",
    registrationCode: "",
    siteId: -1,
    deviceTypeId: -1,
    costCenterId: -1,
    productStateId: -1,
    // locationId: -1,
    assignedDate: null as string | null,
    activationDate: null as string | null,
    productUser: "",
    sourceName: "",
    description: "",
    notes: "",
    deleted: false,
  };
  editedItem = Object.assign({}, this.defaultItem);

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "barCode",
    descending: false,
    page: 1,
    rowsPerPage: this.$cookies.isKey("products-rowsPerPage") ?
                        parseInt(this.$cookies.get("products-rowsPerPage"), 10) : 25
  };
  totalItem = 2;

  showFilters = false;
  filters = {
      "productCode": "",
      "barCode": "",
      "description": "",
      "site.code": "",
      "site.description": "",
      "deviceType.name": "",
      "costCenter.name": "",
      "productState.name": "",
      "lastInventoryDate": { from: "", to: "" },
      "assignedDate": { from: "", to: "" },
      "activationDate": { from: "", to: "" },
    };

  ecoDropdown = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  getHeaders() { return [
      {
        text: "#",
        value: "productId",
        filterCol: "productId",
        width: "1%",
        align: "left",
        filterable: false,
        filterType: "none"
      },
      {
        text: "",
        value: "printLabel",
        filterCol: "printLabel",
        width: "1%",
        sortable: false,
        filterable: false,
        filterType: "none"
      },
      {
        text: this.$t("ITEMS_TABLE_PRODUCT_CODE"),
        value: "productCode",
        filterCol: "productCode",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: this.$t("ITEMS_TABLE_PRODUCT_BAR_CODE"),
        value: "barCode",
        filterCol: "barCode",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: this.$t("ITEMS_TABLE_PRODUCT_NAME"),
        value: "description",
        filterCol: "description",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: this.$t("ITEMS_TABLE_PRODUCT_SITE"),
        value: "site.code",
        filterCol: "site_code",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: this.$t("ITEMS_TABLE_PRODUCT_SITE_NAME"),
        value: "site.description",
        filterCol: "site_description",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: this.$t("ITEMS_TABLE_PRODUCT_DEVICE_TYPE"),
        value: "deviceType.name",
        filterCol: "deviceType_name",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: this.$t("ITEMS_TABLE_PRODUCT_COST_CENTER"),
        value: "costCenter.name",
        filterCol: "costCenter_name",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: this.$t("ITEMS_TABLE_PRODUCT_PRODUCT_STATE"),
        value: "productState.name",
        filterCol: "productState_name",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: this.$t("ITEMS_TABLE_LAST_INVENTORY_DATE"),
        value: "lastInventoryDate",
        filterCol: "lastInventoryDate",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "dateRange"
      },
      {
        text: this.$t("ITEMS_TABLE_ACTIVATION_DATE"),
        value: "activationDate",
        filterCol: "activationDate",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "dateRange"
      },
      {
        text: this.$t("ITEMS_TABLE_ASSIGNED_DATE"),
        value: "assignedDate",
        filterCol: "assignedDate",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "dateRange"
      },
      {
        text: this.$t("ITEMS_TABLE_STATUS"),
        value: "status",
        filterCol: "status",
        width: "1%",
        sortable: false,
        filterable: false,
        filterType: "none"
      },
      {
        text: this.$t("TABLE_ACTIONS"),
        value: "actions",
        filterCol: "actions",
        sortable: false,
        filterable: false,
        filterType: "none"
      }
    ];
  }

  async created() {
    // await this.getLocations();
    await this.getSites();
    await this.getDeviceTypes();
    await this.getCostCenters();
    await this.getProductStates();
    this.searchSites(null);
    // this.searchLocations(null);
    this.searchDeviceTypes(null);
    this.searchCostCenters(null);
    this.searchProductStates(null);

    this.initializeSignalR()
    .then( conn => {
      console.log("initializeSignalR - ok");
      // conn.on("WeightInformation", data => {
      //   console.log("WeightInformation ????");
      // });
    })
    .catch( err => {
      console.error("initializeSignalR: ", err);
    });
  }

  @Watch("editedItem.siteId")
  onSiteIdChanged(newSiteId) {
    if (newSiteId && newSiteId !== -1) {
      // Find the selected site and get its CostCenter
      const selectedSite = this.sitesState.sites.find(site => site.siteId === newSiteId);
      if (selectedSite && selectedSite.costCenter) {
        // Set the costCenterId based on the Site's CostCenter
        this.editedItem.costCenterId = -1;
      }
    } else {
      // Reset costCenterId when no site is selected
      this.editedItem.costCenterId = -1;
    }
    this.searchCostCenters(null);
  }

  getSelectedSiteCostCenter() {
    if (this.editedItem.siteId && this.editedItem.siteId !== -1) {
      const selectedSite = this.sitesState.sites.find(site => site.siteId === this.editedItem.siteId);
      if (selectedSite && selectedSite.costCenter) {
        return selectedSite.costCenter.name;
      }
    }
    return "Nincs kiválasztott telephely";
  }

  reload() {
    this.updatePagination(this.pagination);
  }

  changeSort(column) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
    this.updatePagination(this.pagination);
  }

  triggerFilter() {
    this.serversideSearch();
  }

  toggleFilters() {
    if (this.showFilters) {
      // If hiding filters, clear all filter criteria
      this.clearFilters();
    }
    this.showFilters = !this.showFilters;
  }

  clearFilters() {
    this.filters = {
      "productCode": "",
      "barCode": "",
      "description": "",
      "site.code": "",
      "site.description": "",
      "deviceType.name": "",
      "costCenter.name": "",
      "productState.name": "",
      "lastInventoryDate": { from: "", to: "" },
      "assignedDate": { from: "", to: "" },
      "activationDate": { from: "", to: "" },
    };
    // Trigger search to refresh results without filters
    this.serversideSearch();
  }

  // lapozáskor hívódik meg, ill. ha item/oldalszámot választunk
  updatePagination(pagination) {

    this.$cookies.set("products-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
      filters: JSON.stringify(this.filters)  // Serialize filters to JSON string
    };
    this.getProducts(page);
  }

  searchSites(e) {
    if (!this.sitesSearchTerm) {
      this.sitesSearched = this.sitesState.sites;
      return;
    }

    const term = this.sitesSearchTerm.toLowerCase();
    this.sitesSearched = this.sitesState.sites.filter((item) => {
      return item.code.toLowerCase().indexOf(term) > -1
        || item.description.toLowerCase().indexOf(term) > -1;
    });
  }

  searchDeviceTypes(e) {
    if (!this.deviceTypesSearchTerm) {
      this.deviceTypesSearched = this.deviceTypesState.deviceTypes;
      return;
    }

    this.deviceTypesSearched = this.deviceTypesState.deviceTypes.filter((item) => {
      return item.name.indexOf(this.deviceTypesSearchTerm.toUpperCase()) > -1 ||
             item.description.indexOf(this.deviceTypesSearchTerm.toUpperCase()) > -1;
    });
  }

  searchCostCenters(e) {
    if (!this.costCentersSearchTerm) {
      this.costCentersSearched = this.costCentersState.costCenters;
      return;
    }

    const term = this.costCentersSearchTerm.toLowerCase();
    this.costCentersSearched = this.costCentersState.costCenters.filter((item) => {
      return item.name.toLowerCase().indexOf(term) > -1
            || item.description.toLowerCase().indexOf(term) > -1;
    });
  }

  searchProductStates(e) {
    if (!this.productStatesSearchTerm) {
      this.productStatesSearched = this.productStatesState.productStates;
      return;
    }

    const term = this.productStatesSearchTerm.toLowerCase();
    this.productStatesSearched = this.productStatesState.productStates.filter((item) => {
      return item.name.toLowerCase().indexOf(term) > -1 ||
             item.description.toLowerCase().indexOf(term) > -1;
    });
  }


  save() {
    // if (this.$refs.form.validate()) {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.editedItem.barCode = this.editedItem.barCode;

      // the following data may be present in the edited user.
      delete (this.editedItem as any).costCenter;
      delete (this.editedItem as any).deviceType;
      // delete (this.editedItem as any).location;
      delete (this.editedItem as any).productState;
      delete (this.editedItem as any).site;

      console.log(this.editedItem);

      this.saveProduct({
        data: JSON.stringify(this.editedItem),
        index: this.editedIndex
      })
        .then(res => {
          this.close();
        })
        .catch(res => {
          // handle....
          // this.close();
        });
    }
  }

  close() {
    this.editingDialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
    if (this.$refs.form) {
      // this.$refs.form.resetValidation();
      (this.$refs.form as Vue & { resetValidation: () => void }).resetValidation();
    }
  }
  editItem(item) {
    this.isNewItem = false;
    this.editedIndex = this.productsState.products.indexOf(item);
    this.editedItem = Object.assign({}, item);

    this.searchCostCenters(null);
    // Format date fields for HTML date inputs (YYYY-MM-DD format)
    if (this.editedItem.activationDate) {
      this.editedItem.activationDate = this.formatDateForInput(this.editedItem.activationDate);
    }
    if (this.editedItem.assignedDate) {
      this.editedItem.assignedDate = this.formatDateForInput(this.editedItem.assignedDate);
    }

    // the following data is present in the user list, needs to be removed when editing
    delete (this.editedItem as any).costCenter;
    delete (this.editedItem as any).deviceType;
    // delete (this.editedItem as any).location;
    delete (this.editedItem as any).productState;
    delete (this.editedItem as any).site;

    this.editingDialog = true;
  }
  deleteItem(item) {
    const index = this.productsState.products.indexOf(item);

    // Store the item and index for later use
    this.itemToDelete = item;
    this.itemIndexToDelete = index;

    // Show the status confirmation dialog
    (this.$refs.deleteStatusConfirmationDialog as any).show();
  }

  showInventoryHistory(item) {
    this.selectedProduct = item;
    this.inventoryHistoryDialog = true;
  }

  onDeleteStatusConfirmed(selectedStatus: number) {
    if (this.itemToDelete) {
      // Call deleteProduct with the new status
      const delBody = {
        id: this.itemToDelete.productId,
        index: this.itemIndexToDelete,
        newStatus: selectedStatus
      };
      console.log(delBody);
      this.deleteProduct(delBody);

      // Reset the stored item
      this.itemToDelete = null;
      this.itemIndexToDelete = -1;
    }
  }

  onDeleteStatusCancelled() {
    // Reset the stored item
    this.itemToDelete = null;
    this.itemIndexToDelete = -1;
  }

  formatDate(date) {
    if (!date) {
      return "N/A";
    }
    return new Date(date).toLocaleDateString();
  }

  formatDateForInput(date) {
    if (!date) {
      return "";
    }
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  // File Management Methods
  showFileManagement(item) {
    this.selectedProduct = item;
    this.fileManagementDialog = true;
  }

  // Download methods
  downloadProductsData() {
    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: this.pagination.sortBy,
      descending: this.pagination.descending,
      page: this.pagination.page,
      rowsPerPage: this.pagination.rowsPerPage,
      searchString: x,
      filters: JSON.stringify(this.filters)
    };
    importExportApi.downloadProductExport(page, "termek-export.xlsx");
  }

    // Download methods
  downloadUHJProductsData() {
    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: this.pagination.sortBy,
      descending: this.pagination.descending,
      page: this.pagination.page,
      rowsPerPage: this.pagination.rowsPerPage,
      searchString: x,
      filters: JSON.stringify(this.filters)
    };
    importExportApi.downloadUHJProductExport(page, "ÜHJ-sablon.xlsx");
  }

  // Print Label Methods
  showPrintLabel(item) {
    this.selectedProduct = item;
    this.printLabelDialog = true;
  }

  addPrintLabel(item) {
    const labelToAdd = {
      id: item.id,
      barCode: item.barCode,
      name: item.description
    };

    this.printLabelOverlay = true;
    this.addToPrint(labelToAdd);
  }

  onPrintLabel(label) {
    console.log("Label printed:", label);

    const labelData = {
      labelId: "1",
      barCode: label.barCode,
      name: label.productName,
    };

    console.log(labelData);

    this.printZebraLabel(labelData)
    .then( res => {
      console.log("Címke sikeresen elküldve nyomtatásra");
      appSnackbarService.success(
          "Címke sikeresen elküldve nyomtatásra"
      );
    })
    .catch(err => {
      console.error("Hiba történt nyomtatás során: ", err);
      appSnackbarService.error(
        "Hiba történt nyomtatás során"
      );
    });

    console.log("printed...");
    // Here you can add any additional logic after label printing
  }
}
